module.exports = __webpack_public_path__ + "img/galeria.638a9fae.png";